<template>
<div>
  <div class="bg-primary-lightest py-10">
    <div class="static-container text-center sm:text-left">
      <h2 class="text-3xl sm:text-6xl font-bold">
        Удаление аккаунта
      </h2>
    </div>
  </div>
  <div v-if="store" class="static-container mt-10">
    <div class="legal-document-content prose mb-4 max-w-full px-4 sm:px-0">
      <p>
        <template v-if="hasAppStore && hasGooglePlay">
          В приложениях <span class="font-bold">{{ store.name }}</span>, опубликованных в
          <a :href="appStoreUrl" target="_blank" class="underline">App Store</a>
          и
          <a :href="googlePlayUrl" target="_blank" class="underline">Google Play</a>,
        </template>
        <template v-else-if="hasAppStore">
          В приложении <span class="font-bold">{{ store.name }}</span>, опубликованном в
          <a :href="appStoreUrl" target="_blank" class="underline">App Store</a>,
        </template>
        <template v-else-if="hasGooglePlay">
          В приложении <span class="font-bold">{{ store.name }}</span>, опубликованном в
          <a :href="googlePlayUrl" target="_blank" class="underline">Google Play</a>,
        </template>
        <template v-else>В приложениях <span class="font-bold">{{ store.name }}</span></template>
        есть возможность удалить свой аккаунт.
      </p>
      <h3>Как удалить аккаунт в приложении?</h3>
      <ul>
        <li>Открыть приложение</li>
        <li>Перейти на страницу <span class="font-bold">«Профиль → Мои данные»</span>;</li>
        <li>Внизу страницы нажать на кнопку <span class="font-bold">«Удалить аккаунт»</span>;</li>
        <li>Подтвердить удаление аккаунта (может потребоваться ввод пароля).</li>
      </ul>

      <h3>Какие данные будут удалены?</h3>
      <ul>
        <li>Будут удалены все данные о покупателе из базы клиентов;</li>
        <li>Будет удалены: ФИО, телефон, пароль, адреса, привязанные карты оплаты.</li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
import InjectsSeo from '@/mixins/InjectsSeo';
import { mapGetters } from 'vuex';

export default {
  mixins: [InjectsSeo],
  metaInfo() {
    return {
      title: this.getFullPageTitle('Удаление аккаунта'),
    };
  },

  computed: {
    ...mapGetters({
      store: 'store/store',
    }),

    hasAppStore() {
      return !!this.store.settings?.applications?.app_store?.url;
    },

    appStoreUrl() {
      return this.store.settings?.applications?.app_store?.url || '';
    },

    hasGooglePlay() {
      return !!this.store.settings?.applications?.google_play?.url;
    },

    googlePlayUrl() {
      return this.store.settings?.applications?.google_play?.url || '';
    },
  },
}
</script>
